import { render, staticRenderFns } from "./MandateTypes.vue?vue&type=template&id=881a8946&scoped=true&"
import script from "./MandateTypes.vue?vue&type=script&lang=js&"
export * from "./MandateTypes.vue?vue&type=script&lang=js&"
import style0 from "./MandateTypes.vue?vue&type=style&index=0&id=881a8946&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "881a8946",
  null
  
)

export default component.exports